import { render, staticRenderFns } from "./SectionAddModal.vue?vue&type=template&id=4984a33a&scoped=true"
import script from "./SectionAddModal.vue?vue&type=script&lang=js"
export * from "./SectionAddModal.vue?vue&type=script&lang=js"
import style0 from "./SectionAddModal.vue?vue&type=style&index=0&id=4984a33a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4984a33a",
  null
  
)

export default component.exports